<app-manager-dashboard *ngIf="user.role === roles.Manager"></app-manager-dashboard>
<app-intake-dashboard *ngIf="user.role === roles.Intake"></app-intake-dashboard>
<app-supervisor-dashboard *ngIf="user.role === roles.Supervisor"></app-supervisor-dashboard>
